/* RNRK9 product card colour swatches (snippets/rnrk9-card-swatches.liquid)
   Hover or tap a dot: swaps the card image to that colour and points the card
   link at that variant. Tapping a dot never navigates on its own. */
(function () {
  if (window.rnrk9CardSwatchInit) return;
  window.rnrk9CardSwatchInit = true;

  function select(dot) {
    var card = dot.closest('.rnrk9-prod-card');
    if (!card || dot.classList.contains('is-active')) return;

    var row = dot.parentElement;
    row.querySelectorAll('.rnrk9-card-sw__dot.is-active').forEach(function (d) {
      d.classList.remove('is-active');
    });
    dot.classList.add('is-active');

    var url = dot.getAttribute('data-url');
    if (url) {
      if (card.tagName === 'A') card.setAttribute('href', url);
      card.querySelectorAll('.rnrk9-prod-card__img a, .rnrk9-prod-card__name a').forEach(function (a) {
        a.setAttribute('href', url);
      });
    }

    var variantId = dot.getAttribute('data-variant-id');
    if (variantId) {
      var add = card.querySelector('.rnrk9-prod-card__add[data-variant-id]');
      if (add && dot.getAttribute('data-available') === 'true') add.setAttribute('data-variant-id', variantId);
      var notify = card.querySelector('.rnrk9-notify-wrap[data-variant-id]');
      if (notify) notify.setAttribute('data-variant-id', variantId);
    }

    var src = dot.getAttribute('data-img');
    var img = card.querySelector('.rnrk9-prod-card__img img');
    if (!src || !img) return;
    img.setAttribute('data-rnrk9-want', src);
    img.classList.add('is-swapping');
    var next = new Image();
    next.onload = next.onerror = function () {
      if (img.getAttribute('data-rnrk9-want') !== src) return;
      img.removeAttribute('srcset');
      img.src = src;
      img.classList.remove('is-swapping');
    };
    next.src = src;
  }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('[data-rnrk9-swatch]');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    select(dot);
  }, true);

  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseover', function (e) {
      var dot = e.target.closest && e.target.closest('[data-rnrk9-swatch]');
      if (dot) select(dot);
    });
  }
})();
